export default {
    title: "Reduceri",
    description: "Beneficii si reduceri",
    info: {
        total_value: "Această reducere este oferită integral de partener.\n" +
            "Nu afectează prețul plătit de utilizator și nici comisionul platformei.\n" +
            "Este administrată din panoul de administrare, în pagina „Adm – Discounts”\n" +
            "Fii atent la modificare, consulta inainte pagina de administrare a reducerii si anume platform_value sa nu fie mai mare decat valoarea introdusa de tine"
    },
    table: {
        provider: "Furnizor",
        brand: "Brand",
        benefit_name: "Beneficiu",
        type: "Tip",
        full_price: "Pret (RON)",
        user_price: "Pret utilizator (RON)",
        discount: {
            total: "Total",
            user_value: "Reducere utilizator",
            platform_fee_value: "Reducere comision platforma",
            user_price: "Pret afisat utilizator",
            platform_fee_price: "Pret comision platforma",
            calculator: "Calculator",
        },
        actions: "Actiuni",

        tooltips: {
            provider: "Compania care ofera beneficiul.",
            type: "Procent/Fix",
            brand: "Brand sau categorie de produs.",
            benefit_name: "Numele beneficiului.",
            full_price: "Pretul integral al produsului.",
            actions: "Editeaza sau sterge reducerea.",
            discount: {
                total: "Reducere totala (%/RON)",
                user_value: "Reducere utilizator (%/RON)",
                platform_fee_value: "Reducere comision platforma (%/RON)",
                user_price: "Pretul afisat utilizatorului",
                platform_fee_price: "Pret comision platforma",
                calculator: "Calculator",
            },
        },
    },
};
